inits.push("initInfoBox()");

// console.log("initInfoBox");


window.initInfoBox = () => {
    $('.iconSelection').each(function() {
        var val = $(this).val();
        $(this).prev().val(val);
    });
    // console.log($(".icons.dropdown"));
    /* SELECT-Listen */
    $(".icons.dropdown").each(function() {
        // stylen des dropdowns
        $(this).selectmenu().data("ui-selectmenu")._renderItem = function(ul, item) {
            var li = $('<li class="icon icon-' + item.value + '">');
            return li.appendTo(ul);
        };
    });

    $(".colors.dropdown").each(function() {
        var target = this;

        // stylen des dropdowns
        $(this).selectmenu().data("ui-selectmenu")._renderItem = function(ul, item) {
            var li = $('<li class="color ' + item.value + '">');
            // aendern der farben bei auswahl des dropdowns
            li.click(function(ev) {
                $(target).parents('.bar-vertical').removeClass("neutral signal-0 signal-1 signal-2");
                $(target).parents('.bar-vertical').addClass(item.value);
            });
            return li.appendTo(ul);
        };

    });

}
